import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExperiencesComponent } from './experiences/experiences.component';
import { ProductsComponent } from './experiences/products/products.component';
import { CalendarComponent } from './experiences/calendar/calendar.component';
import { BookingComponent } from './experiences/booking/booking.component';
import { BookingsComponent } from './bookings/bookings.component';
import { ReportsComponent } from './reports/reports.component';
import { ManageComponent } from './manage/manage.component';
import {ProductDetailsComponent} from './experiences/products/product-details/product-details.component';
import {ProductEventsComponent} from './experiences/products/product-events/product-events.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import {LoginComponent} from './login/login.component';
import {ExploreComponent} from './explore/explore.component';
import {SupplierComponent} from './explore/supplier/supplier.component';

const routes: Routes = [
  {
    path: '',
    // component: OverviewComponent,
    component: ExperiencesComponent,
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'experiences',
    component: ExperiencesComponent
  },
  {
    path: 'partner/:id',
    children: [
      { path: '', redirectTo: 'calendar', pathMatch: 'full' },
      { path: 'products', component: ProductsComponent },
      { path: 'product-detail/:productId', component: ProductDetailsComponent },
      { path: 'product-events/:productId', component: ProductEventsComponent },
      { path: 'calendar', component: CalendarComponent },
      { path: 'book/:eventId', component: BookingComponent }
    ]
  },
  {
    path: 'explore',
    component: ExploreComponent
  },
  {
    path: 'supplier/:id',
    component: SupplierComponent
  },
  {
    path: 'bookings',
    component: BookingsComponent
  },
  {
    path: 'reports',
    component: ReportsComponent
  },
  {
    path: 'manage',
    component: ManageComponent
  },
  {
    path: 'profile',
    component: UserProfileComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
  providers: []
})
export class RoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts